<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>Examination Score By MAC Address</h5>
    <div *ngIf="!exportedFile.file">
      <div class="row">
        <div class="mb-3 mr-0 col-md-6">
          <div class="form-check mb-3 mr-0 col-md-12">
            <input class="form-check-input" type="checkbox" [(ngModel)]="skipImportCandidateData"
              [ngModelOptions]="{ standalone: true }">
            <label class="form-label">Skip Import Candidate Data</label>
          </div>
        </div>
        <div class="mb-3 mr-0 col-md-4">
          <input class="form-check-input" type="checkbox" [(ngModel)]="excludeTestCandidates"
            [ngModelOptions]="{ standalone: true }">
          <label class="form-check-label ml-1" for="flexCheckDefault">
            Exclude Test Candidates
          </label>
        </div>
      </div>
      <button class="btn btn-primary btn-lg col-md-12" (click)="generateReport()" *ngIf="!exportedFile.file">
        Generate Report
      </button>
    </div>
    <app-file-download *ngIf="exportedFile.file" [exportedFile]="exportedFile"></app-file-download>
  </div>
</div>